import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { IPinPool } from '../models/cardgroup.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Gets an individual card group
 * 
 * @param {string} groupId the card group id
 * @param {string} customerId the customer id
 * @param {string} partnerId the partner id
 * 
 * @returns {Promise} the api response - interface ICardGroupResponse
 */
const GetCardGroupPinPool = async (groupId?: string, customerId?: string, partnerId?: string): Promise<IPinPool> => {
  try {
    apiRetry(awsApiInstance);

    const { userId } = useAuth()!;

    const { data } = await awsApiInstance.get(`/card-group/${groupId}/pin-pool`,  {
      params: {
        wpId: userId,
        customerID: customerId,
        partnerID: partnerId,
        cardGroupID: groupId
      }
    });

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error getting card group pin pool data');
    throw(error);
  }
}

export default GetCardGroupPinPool;